// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"3ef1ef02","977":"d655b491"}[chunkId] + ".chunk.js";
};